import * as React from "react";
import Seo from "@components/seo";
import Layout from "@layout";
import Header from "@layout/header/header-four";
import Footer from "@layout/footer/footer-one";
import IntroArea from '@containers/our-history/intro-area'
import HistoryArea from '@containers/our-history/history-area'

const HistoryPage = ({ pageContext, location }) => (
	<Layout location={location}>
		<Seo title="Nuestra Historia" />
		<Header />
		<main className="site-wrapper-reveal">
			<IntroArea />
			<HistoryArea />
		</main>
		<Footer />
	</Layout>
)

export default HistoryPage
